import { PrintFontWeight } from '../../../types/graphqlTypes';
import type { OrgPrintFont } from './printFonts';

/** The brand kit's fonts as the font loader takes them. */
export const orgPrintFontsOf = (fonts: readonly { id: string; family: string; weight: PrintFontWeight; italic: boolean; url: string }[] | null | undefined): OrgPrintFont[] =>
  (fonts ?? []).map((f) => ({ id: f.id, family: f.family, weight: f.weight === PrintFontWeight.Bold ? 'bold' : 'normal', italic: f.italic, url: f.url }));
